import { ILocationPath, Location } from './location';
import { OneLakeFileLinkedService } from '../../linkedservice/one-lake-file.linkedservice';
import { Metamodel } from '../../base/model';
import { IAttribute, IModel } from '../../base/annotation';
import { FilePath } from '../file-path';
import { stringIsNullOrEmpty } from '../../../shared/utils/string.util';
import { shellStringResources } from '../../../Resources/ShellStringResources';

// Paths are relative to the workspace/item in the connection's DSR path, so there is no container segment.
@Metamodel.model({
    name: 'OneLakeFilesLocation',
    tags: { linkedServiceModel: Metamodel.modelFor(OneLakeFileLinkedService) }
})
export class OneLakeFilesLocation extends Location {
    public static readonly MODEL: IModel;
    public static readonly FOLDER_PATH: IAttribute;
    public static readonly FILE_NAME: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.FolderPath_Label,
        association: 'FOLDER_PATH',
        templatable: true
    })
    public folderPath?: string;

    @Metamodel.attribute({
        display: shellStringResources.FileNameLabel,
        association: 'FILE_NAME',
        templatable: true
    })
    public fileName?: string;

    public setLocation(path: FilePath): void {
        this.folderPath = path.folderPath;
        this.fileName = path.fileName;
    }

    public setParameterizedLocation(path: ILocationPath): void {
        this.setPathPropertyValue('folderPath', OneLakeFilesLocation.FOLDER_PATH, path);
        this.setPathPropertyValue('fileName', OneLakeFilesLocation.FILE_NAME, path);
    }

    public getLocation(): FilePath {
        const path = new FilePath();
        path.folderPath = this.folderPath;
        path.fileName = this.fileName;
        return path;
    }

    public getParameterizedLocation(): ILocationPath {
        return {
            folderPath: OneLakeFilesLocation.FOLDER_PATH.templateValue(this) || this.folderPath,
            fileName: OneLakeFilesLocation.FILE_NAME.templateValue(this) || this.fileName
        };
    }

    public getFolderPath(): string {
        return this.folderPath;
    }

    public isFolder(fileNameParameterAsFile: boolean = true): boolean {
        return fileNameParameterAsFile && OneLakeFilesLocation.FILE_NAME.templateValue(this) ? false : !this.fileName;
    }

    public isLocationParameterized(): boolean {
        return (
            !stringIsNullOrEmpty(OneLakeFilesLocation.FOLDER_PATH.templateValue(this)) ||
            !stringIsNullOrEmpty(OneLakeFilesLocation.FILE_NAME.templateValue(this))
        );
    }
}
